export default "__VITE_ASSET__5sNzViYF__"